module.exports = __webpack_public_path__ + "static/media/video@3x.db9d028b.webp";